import React from 'react';

import { Flex } from '@chakra-ui/react';
import { usePartialPublishEventDetails } from 'screens/performanceReview/helpers';

import { CheckCircle, ErrorOutline } from 'assets/assetsV1/iconComponents';

import { sendBulkNotifyCloseReviewsEvent } from 'constants/mixpanelHelpers/bulkNotifyEvents';

import { DrawerBody, DrawerFooter, DrawerHeaderSecondary } from 'uiToolkitV1/BottomDrawer';
import { Button } from 'uiToolkitV1/Button';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

import { useBulkNotifyContext } from '../BulkNotifyContext';

const SuccessScreen = () => (
  <Flex flexDir="column" mx={5} mb="120px" pt={4}>
    <Flex
      flexDir="column"
      bg="radial-gradient(299.07% 219.61% at 50% 50%, rgba(219, 242, 211, 0.00) 0%, #DBF2D3 97.92%)"
      p="30px 16px 40px"
      borderRadius="8px"
      alignItems="center"
      border="1px solid"
      borderColor="border.EBEFF3"
    >
      <CheckCircle color="functional.44812F" boxSize="92px" mb={3} />
      <TextBodyMedium bold color="functional.44812F">
        Notifications sent successfully!
      </TextBodyMedium>
      <TextLabel color="text.g2">Notifications have been sent to selected team members</TextLabel>
    </Flex>
  </Flex>
);

const FailureScreen = () => (
  <Flex flexDir="column" mx={5} mb="120px" pt={4}>
    <Flex
      flexDir="column"
      bg="radial-gradient(299.07% 219.61% at 50% 50%, rgba(242, 213, 211, 0.00) 0%, #F2D5D3 97.92%)"
      p="30px 16px 40px"
      borderRadius="8px"
      alignItems="center"
      border="1px solid"
      borderColor="border.EBEFF3"
    >
      <ErrorOutline color="functional.C62C02" boxSize="92px" mb={3} />
      <TextBodyMedium bold color="functional.C62C02">
        Task Failed
      </TextBodyMedium>
      <TextLabel color="text.g2">Notifications could not be sent, please try again</TextLabel>
    </Flex>
  </Flex>
);

const BulkNotifyResult = ({ onClose }) => {
  const { bulkNotifySuccessful } = useBulkNotifyContext();

  const { page, module } = usePartialPublishEventDetails();

  const onCloseWithEvent = () => {
    sendBulkNotifyCloseReviewsEvent({
      eventProperties: {
        page,
        source: module,
        type: bulkNotifySuccessful ? 'success' : 'failure',
      },
    });
    onClose();
  };

  return (
    <>
      <DrawerHeaderSecondary onClose={onCloseWithEvent}>
        <Flex
          alignItems="center"
          borderBottom="1px"
          borderBottomColor="neutral.CFD7DF"
          mx={4}
          py={5}
          justifyContent="space-between"
        >
          <Flex flexDir="column">
            <TextBodyMedium bold>Notify Pending Reviewers for selected employees</TextBodyMedium>
          </Flex>
        </Flex>
      </DrawerHeaderSecondary>
      {bulkNotifySuccessful !== null && (
        <DrawerBody>{bulkNotifySuccessful ? <SuccessScreen /> : <FailureScreen />}</DrawerBody>
      )}
      <DrawerFooter>
        <Button w="94px" variant="filled" colorScheme="blue" onClick={onCloseWithEvent}>
          Done
        </Button>
      </DrawerFooter>
    </>
  );
};

export { BulkNotifyResult };
